var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 238.20345 208.82396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 229.45673,208.82394 v 0 l -220.7300039,-0.28 a 8.74,8.74 0 0 1 -7.55,-13.12 L 111.78673,4.423936 a 8.73,8.73 0 0 1 7.51,-4.39000001 c 2.85,-0.32 6,1.66000001 7.57,4.38000001 l 110.17,191.320004 a 8.73,8.73 0 0 1 -7.58,13.09 z m -205.580004,-17.71 190.460004,0.24 -95.04,-165.100004 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 107.72673,165.34394 a 9.6,9.6 0 1 1 2.81,6.69 9.13,9.13 0 0 1 -2.81,-6.69 z m 16.13,-20.7 h -13.82 V 72.163936 h 13.82 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a0d8425b53d215a10c798039dd054d32.svg";
export { ForwardRef as ReactComponent };